// Full SystemsHeader mega-menu data — every item is a real, functional route.
// Routes match those declared in /app/frontend/src/App.js.

export const SYSTEMS_MENU = {
  solutions: {
    label: 'Solutions',
    href: '/systems/solutions',
    groups: [
      {
        heading: 'MANAGED IT',
        icon: 'AlignJustify',
        items: [
          { label: 'Managed IT Services', icon: 'MonitorSmartphone', href: '/systems/solutions/managed-it-services' },
          { label: 'IT Systems Management', icon: 'Settings2', href: '/systems/solutions/it-systems-management' },
          { label: 'IT Help Desk & Remote Support', icon: 'MessageCircle', href: '/systems/solutions/it-help-desk-remote-support' },
        ],
      },
      {
        heading: 'SECURITY & PROTECTION',
        icon: 'Lock',
        items: [
          { label: 'Cybersecurity Support', icon: 'ShieldCheck', href: '/systems/solutions/cybersecurity-support' },
          { label: 'Backup & Data Protection', icon: 'Database', href: '/systems/solutions/backup-data-protection' },
          { label: 'Surveillance Camera Deployment', icon: 'Camera', href: '/systems/solutions/surveillance-system-deployment' },
        ],
      },
      {
        heading: 'INFRASTRUCTURE',
        icon: 'Settings',
        items: [
          { label: 'Cloud & Infrastructure Support', icon: 'Cloud', href: '/systems/solutions/cloud-infrastructure-support' },
          { label: 'Network Infrastructure', icon: 'Wifi', href: '/systems/solutions/network-infrastructure-management' },
          { label: 'IT Infrastructure Deployment', icon: 'Plane', href: '/systems/solutions/it-infrastructure-deployment' },
        ],
      },
      {
        heading: 'DEVELOPMENT & ADVISORY',
        icon: 'Wrench',
        items: [
          { label: 'Website Development', icon: 'Globe', href: '/systems/solutions/website-development' },
          { label: 'Application Development', icon: 'LayoutGrid', href: '/systems/solutions/application-development' },
          { label: 'IT Consulting & Technology Advisory', icon: 'Key', href: '/systems/solutions/it-consulting-technology-advisory' },
        ],
      },
    ],
    featured: {
      label: 'FEATURED',
      title: 'ZHELTA Systems Platform',
      body: 'Professional IT services designed for individuals, businesses, and organizations.',
      bullets: [
        'Comprehensive IT management',
        '24/7 support and monitoring',
        'Scalable solutions',
      ],
      cta: 'Compare service tiers',
      ctaHref: '/systems/pricing',
    },
    footer: [
      { label: 'View Pricing', href: '/systems/pricing' },
      { label: 'Book a Demo', href: 'https://portal.zhelta.com/p/scheduler/KfMLXSkC6pkS4utFn' },
      { label: 'Talk to Sales', href: '/systems/contact' },
    ],
  },

  products: undefined,

  pricing: {
    label: 'Pricing',
    href: '/systems/pricing',
    groups: [
      {
        heading: 'MANAGED IT',
        icon: 'AlignJustify',
        items: [
          { label: 'Managed IT Services', icon: 'MonitorSmartphone', href: '/systems/solutions/managed-it-services/pricing' },
          { label: 'IT Systems Management', icon: 'Settings2', href: '/systems/solutions/it-systems-management/pricing' },
          { label: 'IT Help Desk & Remote Support', icon: 'MessageCircle', href: '/systems/solutions/it-help-desk-remote-support/pricing' },
        ],
      },
      {
        heading: 'SECURITY & PROTECTION',
        icon: 'Lock',
        items: [
          { label: 'Cybersecurity Support', icon: 'ShieldCheck', href: '/systems/solutions/cybersecurity-support/pricing' },
          { label: 'Backup & Data Protection', icon: 'Database', href: '/systems/solutions/backup-data-protection/pricing' },
          { label: 'Surveillance Camera Deployment', icon: 'Camera', href: '/systems/solutions/surveillance-system-deployment/pricing' },
        ],
      },
      {
        heading: 'INFRASTRUCTURE',
        icon: 'Settings',
        items: [
          { label: 'Cloud & Infrastructure Support', icon: 'Cloud', href: '/systems/solutions/cloud-infrastructure-support/pricing' },
          { label: 'Network Infrastructure', icon: 'Wifi', href: '/systems/solutions/network-infrastructure-management/pricing' },
          { label: 'IT Infrastructure Deployment', icon: 'Plane', href: '/systems/solutions/it-infrastructure-deployment/pricing' },
        ],
      },
      {
        heading: 'DEVELOPMENT & ADVISORY',
        icon: 'Wrench',
        items: [
          { label: 'Website Development', icon: 'Globe', href: '/systems/solutions/website-development/pricing' },
          { label: 'Application Development', icon: 'LayoutGrid', href: '/systems/solutions/application-development/pricing' },
          { label: 'IT Consulting & Technology Advisory', icon: 'Key', href: '/systems/solutions/it-consulting-technology-advisory/pricing' },
        ],
      },
    ],
    featured: {
      label: 'FEATURED',
      title: 'Need a Custom Plan?',
      body: "Get tailored IT solutions designed specifically for your organization's needs.",
      bullets: ['Flexible pricing options', 'Custom service packages', 'Dedicated support team'],
      cta: 'Talk to Sales',
      ctaHref: '/systems/contact',
    },
    footer: [
      { label: 'Compare All Plans', href: '/systems/pricing' },
      { label: 'Book a Demo', href: 'https://portal.zhelta.com/p/scheduler/KfMLXSkC6pkS4utFn' },
    ],
  },

  resources: {
    label: 'Resources',
    // ZHELTA Systems doesn't publish a blog yet, so every entry below
    // points to a real, Systems-specific page that already exists. No
    // pretend whitepapers, no Services consumer-blog cross-pollination.
    // (Feb 2026 — replaced earlier /store/guides links which were Services'
    // laptop/phone buying guides and not relevant for enterprise IT buyers.)
    href: '/systems/solutions',
    groups: [
      {
        heading: 'EXPLORE',
        icon: 'BookOpen',
        items: [
          { label: 'Solutions catalogue',     icon: 'Library',      href: '/systems/solutions' },
          { label: 'Pricing & plans',         icon: 'BarChart3',    href: '/systems/pricing' },
          { label: 'About ZHELTA',            icon: 'FileText',     href: '/about' },
        ],
      },
      {
        heading: 'TALK TO US',
        icon: 'Headphones',
        items: [
          { label: 'Talk to a specialist',    icon: 'MessageCircle', href: '/systems/contact' },
          { label: 'Book a demo',             icon: 'Plane',         href: 'https://portal.zhelta.com/p/scheduler/KfMLXSkC6pkS4utFn' },
        ],
      },
    ],
    featured: {
      label: 'TAILORED IT',
      title: 'Not sure where to start?',
      body: 'Walk through the 12 services in our catalogue with a ZHELTA strategist who scopes the right plan to your size, sector, and budget — no slide-deck pitch, just a working session.',
      bullets: [
        'Free 30-minute scoping call',
        'Side-by-side plan comparison',
        'Custom fit for your stack',
      ],
      cta: 'Schedule a session',
      ctaHref: 'https://portal.zhelta.com/p/scheduler/KfMLXSkC6pkS4utFn',
    },
    footer: [
      { label: 'View all solutions', href: '/systems/solutions' },
      { label: 'Compare pricing',    href: '/systems/pricing' },
      { label: 'Contact sales',      href: '/systems/contact' },
    ],
  },
};
